import { logger } from '@tunasong/models'
import type { Profile, ProfileGear } from '@tunasong/schemas'

/**
 * Extract gear config from a member profile.
 *
 * The caller's own profile carries the full config; other members' profiles are returned as public profiles,
 * where publicProfileSchema projects config.gear to a top-level `gear` field and drops the rest of `config`.
 * Accept either shape.
 */
export const getProfileGear = (profile: Profile): ProfileGear | undefined => {
  const config = profile.config as Record<string, unknown> | undefined
  const gear = ((profile as Profile & { gear?: ProfileGear }).gear ?? config?.gear) as ProfileGear | undefined

  if (!gear) {
    logger.debug('Profile has no gear config', { userId: profile.userId })
  } else if (!gear.requirements || gear.requirements.length === 0) {
    logger.debug('Profile gear has no requirements', { userId: profile.userId, gear })
  } else {
    logger.debug('Profile gear loaded', {
      userId: profile.userId,
      requirementCount: gear.requirements.length,
      requirements: gear.requirements,
    })
  }

  return gear
}
